import {
  Dialog,
  DialogActions,
  DialogContentText,
  DialogProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import styled from '@emotion/styled';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';

const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {
        minWidth: 'unset',
        maxWidth: '100%',
      }
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

export interface AnnotationFormVM {
  annotation: string;
  note: string;
}

interface ModalActualResidenceProps {
  open: boolean;
  onOkClose: () => void;
  onCancel: () => void;
}

const ModalActualResidenceComponent = ({
  open,
  onOkClose, // OK
  onCancel, // KO
}: ModalActualResidenceProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Attenzione
      </PmiDialogTitle>
      <PmiDialogContent style={{ padding: '30px 24px' }}>
        <DialogContentText id="alert-dialog-content">
          {
            "Il nuovo indirizzo corrisponde all'indirizzo di residenza, si vuole continuare con il cambio di indirizzo?"
          }
        </DialogContentText>
      </PmiDialogContent>
      <DialogActions>
        <PmiButton variant="outlined" color="cdmBrand" onClick={onCancel}>
          Chiudi
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrandThird" onClick={onOkClose}>
          Conferma
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalActualResidenceComponent.displayName = 'Modal Actual Residence component';

const ModalActualResidence = memo(ModalActualResidenceComponent);

export default ModalActualResidence;
